import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { createUrlWithParams } from '../../../utils/url';

@Component({
  selector: 'app-page-link',
  templateUrl: './page-link.component.html',
  styleUrls: ['./page-link.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageLinkComponent {
  @Input()
  pageIndex = -1;

  @Input()
  isCurrent = false;

  get url(): string {
    const currentUrl = window.location.href;
    const params = new URLSearchParams(currentUrl);
    params.set('page_index', this.pageIndex.toString());

    return createUrlWithParams(params.toString());
  }

  onClick(event: Event) {
    event.preventDefault();
  }
}
